export default {
  "3": "3个",
  "4": "4个",
  "5": "5个",
  "personalCenterDesign": "个人中心装修",
  "unsavedChanges": "尚未保存",
  "notPublishedDefaultTemplateIsInUse": "尚未发布 · 小程序暂用默认模板",
  "resetTemplate": "重置模板",
  "saveTemplate": "保存模板",
  "publish": "发布",
  "theMiniProgramUsesThePublishedPersonal": "小程序个人中心读取的是「已发布」版本。当前实例尚未发布，终端显示默认模板，与下方草稿预览可能不一致。请确认菜单后点击「发布」。",
  "avatar": "头像",
  "user001": "用户001",
  "member": "会员",
  "pageSettings": "页面设置",
  "pageTitle": "页面标题",
  "pageLayout": "页面风格",
  "style1": "样式一",
  "style2": "样式二",
  "style3": "样式三",
  "titleColor": "标题颜色",
  "black": "黑色",
  "white": "白色",
  "backgroundColor": "背景颜色",
  "reset": "重置",
  "backgroundImage": "背景图片",
  "selectImage": "选择图片",
  "showMembership": "是否显示会员",
  "showNotifications": "是否显示消息通知",
  "personalCenter": "个人中心",
  "noImageURLReturned": "未返回图片地址",
  "backgroundImageUploaded": "背景图已上传",
  "uploadFailed": "上传失败",
  "couldNotLoadData": "加载失败",
  "templateSaved": "模板已保存",
  "couldNotSaveChanges": "保存失败",
  "restoreThePersonalCenterToTheDefault": "将个人中心还原为系统默认模板？未发布内容会覆盖当前草稿。",
  "defaultTemplateRestored": "已重置为默认模板",
  "couldNotResetTemplate": "重置失败",
  "personalCenterPublished": "个人中心已发布",
  "couldNotPublish": "发布失败",
  "blockSettings": "区块设置",
  "contentSettings": "内容设置",
  "showBlock": "是否显示",
  "administratorEntriesAreShownAccordingToPermissions": "管理员入口按权限自动显隐；本期仅支持改图标与排序，不可新增或改跳转。",
  "recommendedImageSize100100PxDefault": "最佳图片尺寸 100×100；默认模板图存本地，上传走 OSS",
  "dragToReorder": "拖动排序",
  "type": "类型",
  "content": "内容",
  "image": "图片",
  "imageURL": "图片地址",
  "upload": "上传",
  "selectAType": "请选择类型",
  "configure": "设置",
  "addNavigation": "+ 添加导航",
  "styleSettings": "样式设置",
  "componentLayout": "组件布局",
  "layout1": "布局1",
  "layout2": "布局2",
  "itemsPerRow": "每行数量",
  "iconSize": "图标尺寸",
  "textSize": "文字尺寸",
  "fontColor": "字体颜色",
  "iconAndTextSpacing": "图文间距",
  "itemSpacing": "成员间距",
  "iconUploaded": "图标已上传",
  "bottomNavigation": "底部导航",
  "showUpTo5ItemsHomeAnd": "最多同时显示 5 个；「首页」「我的」为固定项，不可隐藏或删除",
  "preview": "浏览",
  "add": "添加",
  "noNavigationItems": "暂无导航项",
  "menuName": "菜单名称",
  "linkType": "跳转类型",
  "inactiveIcon": "未选图标",
  "activeIcon": "选中图标",
  "order": "排序",
  "status": "状态",
  "visible": "显示",
  "hidden": "隐藏",
  "actions": "操作",
  "edit": "编辑",
  "delete": "删除",
  "fixed": "固定",
  "editNavigationItem": "编辑导航项",
  "addNavigationItem": "添加导航项",
  "enterAMenuName": "请输入菜单名称",
  "richText": "图文",
  "internalPage": "内部页面",
  "miniProgram": "小程序",
  "externalLink": "外部链接",
  "richTextContent": "图文内容",
  "enterRichTextContent": "请输入图文内容",
  "selectAnInternalPage": "请选择内部页面",
  "theDestinationOfAFixedNavigationItem": "固定导航不可更换跳转页面",
  "pageParameters": "页面参数",
  "enterPageParametersEGId1": "如需设置页面参数请输入参数信息，如 id=1&cat=2",
  "miniProgramAppID": "小程序Appid",
  "enterTheDestinationMiniProgramAppID": "输入要跳转的小程序Appid信息",
  "pagePath": "页面路径",
  "enterAMiniProgramPagePathE": "输入要跳转的小程序页面路径，如 /page/index/index",
  "enterAFullURLEGHttps": "输入完整网址链接，如 https://www.example.com",
  "externalLinkDomainsMustBeConfiguredIn": "注意：外部链接必须在小程序控制台设置业务域名",
  "iconURLOrEmoji": "图标 URL 或 Emoji",
  "select": "选择",
  "recommendedImageSize8080Px": "图片建议宽度 80*80px",
  "fixedNavigationItemsMustRemainVisible": "固定导航必须保持显示",
  "showUpTo5ItemsIncludingHome": "同时显示最多 5 个（含首页、我的）",
  "oK": "确定",
  "selectIcon": "选择图标",
  "useOutlineIconsForInactiveItemsAnd": "线框建议用于「未选图标」，实心建议用于「选中图标」",
  "noIconsAvailableUploadAnIconFirst": "暂无可选图标，请先上传",
  "navigationPreview": "浏览预览",
  "noHomePageContent": "暂无首页内容",
  "bottomNavigationPreview": "底部导航预览",
  "noVisibleNavigationItems": "暂无显示中的导航项",
  "all": "全部",
  "selectALinkType": "请选择跳转类型",
  "enterOrUploadAnInactiveIcon": "请填写或上传未选图标",
  "enterOrUploadAnActiveIcon": "请填写或上传选中图标",
  "pleaseSelectAStatus": "请选择状态",
  "enterAnExternalURL": "请填写外部链接",
  "enterAMiniProgramAppID": "请填写小程序 Appid",
  "home": "首页",
  "couldNotLoadPreview": "预览加载失败",
  "couldNotLoadInternalPages": "内部页面加载失败",
  "thereAreAlreadyVisibleItemsNewItems": "已有 {p0} 个显示中的导航，新增项将默认设为隐藏",
  "couldNotUploadIcon": "图标上传失败",
  "showUpToNavigationItemsHideAnother": "底部导航最多同时显示 {p0} 个，请先隐藏其他项",
  "saved": "已保存",
  "added": "已添加",
  "homeAndMyAccountAreFixedNavigation": "「首页」和「我的」为固定导航，不可删除",
  "delete137": "确认删除「{p0}」？",
  "deleteNavigationItem": "删除导航项",
  "deleted": "已删除",
  "couldNotDelete": "删除失败",
  "recordRange": "显示第 {from} 到第 {to} 条记录，总共 {total} 条记录",
  "draftVersion": "已保存草稿 v{version}",
  "expiresOn": "到期时间{date}",
  "navigationTitle": "导航标题",
  "memberBlock": "会员服务",
  "systemBlock": "系统服务",
  "adminBlock": "管理员入口",
  "platformService": "平台客服",
  "myAccount": "我的",
  "supplyAndDemand": "供需"
}
